import {
  BankTransferRequest,
  TeamMembersRequestStatus,
} from '__generated__/GQL';

export const getBankTransferStatusDate = (
  bankTransfer: Pick<
    BankTransferRequest,
    'status' | 'createdAt' | 'reviewedAt' | 'cancelledAt' | 'completedAt'
  >,
) => {
  switch (bankTransfer.status) {
    case TeamMembersRequestStatus.Processed:
      return new Date(bankTransfer.reviewedAt ?? bankTransfer.createdAt);
    case TeamMembersRequestStatus.Pending:
      return new Date(bankTransfer.createdAt);
    case TeamMembersRequestStatus.Approved:
      return new Date(bankTransfer.reviewedAt ?? bankTransfer.createdAt);
    case TeamMembersRequestStatus.Completed:
      return new Date(
        bankTransfer.completedAt ??
          bankTransfer.reviewedAt ??
          bankTransfer.createdAt,
      );
    case TeamMembersRequestStatus.Rejected:
      return new Date(bankTransfer.reviewedAt ?? bankTransfer.createdAt);
    case TeamMembersRequestStatus.Canceled:
      return new Date(
        bankTransfer.cancelledAt ??
          bankTransfer.reviewedAt ??
          bankTransfer.createdAt,
      );
    default:
      return new Date(bankTransfer.createdAt);
  }
};
